/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import {
  ReactNode,
  useEffect,
  useMemo,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from 'react'
import {Column} from 'react-table'
import AsyncSelect from 'react-select/async'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {SelectOption} from '../../../../../../models/utility.model'
import {RatioRoomingListData} from '../../../../models/reports.model'
import {
  getRatioRoomingListResumidoService,
  getRatioRoomingListResumidoExcelService,
  getRatioRoomingTotalesService,
  deleteReserveBedBatchService,
} from '../../../../services/ratio.service'
import {getSnackBarToast} from '../../../../../../util/snackBar'
import Swal from 'sweetalert2'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {SnackbarProvider} from 'notistack'
import {getMasterModuleService} from '../../../modules/services'
import {
  getListComboHuespedService,
  createReserveCheckInBatchService,
  getHuespedEsRelevoService,
  downloadPDFCheckInOutService,
  getListCargosService,
} from '../../../../services/booking.service'
import {ModalCreateGuest} from '../../../booking-face-to-face/components/Modals/ModalCreateGuest'
import {GuestModel} from '../../../guests/model'
import {ModalGenerarReserva} from '../Modals/ModalGenerarReserva'

interface Props {
  formValue: any
  onStatusChange?: (status: {canLiberate: boolean; canGenerate: boolean; loading: boolean}) => void
  paginationLeftActions?: ReactNode
}

interface TableData extends RatioRoomingListData {
  Id: string | number
  Cargo?: string | null
  NroDocAnterior?: string | null
  UsuarioId?: string | null
  HuespedObservacionNombreCompleto?: string | null
  CamaIdPosicion?: string | null
  HuespedOcupado?: boolean | null
  HuespedBuscadorHabilitado?: boolean | null
  HuespedIdAnterior?: string | null
  UsuarioIdAnterior?: string | null
  HuespedObservacionNombreCompletoAnterior?: string | null
}

export interface TableLiberacionGeneracionRef {
  handleSearch: () => void
  handleLiberacion: () => void
  handleGeneracion: () => void
  handleExportExcel: () => Promise<void>
}

const TableReportLiberacionGeneracion = forwardRef<TableLiberacionGeneracionRef, Props>(
  ({formValue, onStatusChange, paginationLeftActions}, ref) => {
    const {
      setData,
      setPagination,
      loading,
      setLoading,
      pagination,
      selected,
      clearSelected,
      updateTable,
      setUpdateTable,
      updateTableDetail,
      setUpdateTableDetail,
      clearTable,
      setClearTable,
      clearTableDetail,
      setClearTableDetail,
    } = useKTable()

    const [tableData, setTableData] = useState<TableData[]>([])

    const [statusBed, setStatusBed] = useState<SelectOption[]>([])
    const [bedTypes, setBedTypes] = useState<SelectOption[]>([])
    const [statusType, setStatusType] = useState<SelectOption[]>([])
    const [enterprises, setEnterprises] = useState<SelectOption[]>([])
    const [cargoById, setCargoById] = useState<Record<string, string>>({})
    const [showModalCreateGuest, setShowModalCreateGuest] = useState<boolean>(false)
    const [pendingDocumento, setPendingDocumento] = useState<{numero: string; tipo: string} | null>(
      null,
    )
    const [pendingRowId, setPendingRowId] = useState<string | number | null>(null)
    const [showModalGenerarReserva, setShowModalGenerarReserva] = useState<boolean>(false)
    const [totals, setTotals] = useState({
      total: 0,
      disponibles: 0,
      ocupadas: 0,
      reservadas: 0,
      bloqueadas: 0,
    })
    const [estadoCamaFilter, setEstadoCamaFilter] = useState<string>('')
    const camaCaliente = [
      {value: 'SI', label: 'SI'},
      {value: 'NO', label: 'NO'},
    ]

    const {searchValues} = useKhipu()
    const {getMasterTable, getEnterprises} = useCentralServices()

    const getMasterTableFn = async (table: string) => {
      try {
        const response = await getMasterModuleService({
          pageNumber: 1,
          size: 100,
          tableName: table,
        })
        const data = response.data.data
        const mappedMaster = data?.map((master) => ({
          value: master.nombreCorto,
          label: master.nombreCorto,
          ...master,
        }))
        return mappedMaster
      } catch (error) {
        console.log(error)
        return []
      }
    }
    useEffect(() => {
      const loadCombos = async () => {
        const dataStatusBed = await getMasterTableFn('EstadoCama')
        const allStatusBed = [{value: '', label: 'TODOS'}, ...(dataStatusBed || [])]
        setStatusBed(allStatusBed)

        const dataBedTypes = await getMasterTable('TipoCama', true)
        const allBedTypes = [{value: '', label: 'TODOS'}, ...(dataBedTypes || [])]
        setBedTypes(allBedTypes)

        const dataStatusType = await getMasterTableFn('EstadoReservaCamaHuesped')
        const allStatusType = [{value: '', label: 'TODOS'}, ...(dataStatusType || [])]
        setStatusType(allStatusType)

        const dataEnterprises = await getEnterprises({isCombo: true}, 1)
        const allEnterprises = [{value: '', label: 'TODOS'}, ...(dataEnterprises || [])]
        setEnterprises(allEnterprises)

        try {
          const cargosResp = await getListCargosService()
          const cargosData = cargosResp?.data?.data || []
          const mappedCargos = cargosData.reduce((acc: Record<string, string>, item: any) => {
            if (item?.Id != null) {
              acc[String(item.Id)] = item.NombreCorto || item.NombreLargo || ''
            }
            return acc
          }, {})
          setCargoById(mappedCargos)
        } catch (error) {
          setCargoById({})
        }
      }

      loadCombos()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const loadTableData = async (filters: any = null, paginationData: any = null) => {
      try {
        setLoading(true)
        const currentPagination = paginationData || pagination
        const obj = {...formValue}
        for (var clave in obj) {
          if (obj.hasOwnProperty(clave)) {
            if (obj[clave] === '') {
              obj[clave] = null
            }
          }
        }

        const hasEstadoCamaInFilters =
          filters && Object.prototype.hasOwnProperty.call(filters, 'EstadoCama')
        const estadoCamaToApply = hasEstadoCamaInFilters ? filters?.EstadoCama : estadoCamaFilter

        const formValues = {
          ...obj,
          ...searchValues,
          ...filters,
          ...(searchValues.CamaCaliente === 'SI'
            ? {CamaCaliente: true}
            : searchValues.CamaCaliente === 'NO'
            ? {CamaCaliente: false}
            : {CamaCaliente: null}),
          pageNumber: currentPagination.currentPage,
          size: currentPagination.perPage,
        }
        if (estadoCamaToApply) {
          formValues.EstadoCama = estadoCamaToApply
        } else {
          delete formValues.EstadoCama
        }

        const {data: response} = await getRatioRoomingListResumidoService(formValues)

        if (!response.error) {
          if (response.data && Array.isArray(response.data)) {
            const mappedData: TableData[] = response.data.map((item, index) => {
              // Si el estado es disponible y ReservaId es null, usar el índice como Id
              const estadoCama = item.EstadoCamaNombre?.toUpperCase()
              const esDisponible = estadoCama === 'DISPONIBLE'
              const tieneReservaId = item.ReservaId != null

              return {
                ...item,
                Id:
                  esDisponible && !tieneReservaId
                    ? index
                    : item.ReservaCamaId != null
                    ? item.ReservaCamaId
                    : index,
                UsuarioId: (item as any).UsuarioId || null,
                NroDocAnterior: item.NroDoc || null,
                HuespedIdAnterior: item.HuespedId || null,
                UsuarioIdAnterior: (item as any).UsuarioId || null,
                HuespedObservacionNombreCompletoAnterior:
                  (item as any).HuespedObservacionNombreCompleto || item.HuespedNombre || null,
              }
            })

            setTableData(mappedData)
            setData(mappedData)

            // Intentar obtener totales desde el servicio dedicado
            try {
              // Duplicar el request: para totales no enviar EstadoCama
              const totalsDto: any = {...formValues}
              if ('EstadoCama' in totalsDto) {
                delete totalsDto.EstadoCama
              }
              const totResp = await getRatioRoomingTotalesService(totalsDto)
              // La API devuelve un arreglo con un objeto: [{ CamasTotales, CamasDisponibles, ... }]
              const raw = totResp?.data
              const list =
                (Array.isArray(raw?.data) ? raw.data : Array.isArray(raw) ? raw : []) || []
              const item = list[0] || {}

              const newTotals = {
                total: item.CamasTotales,
                disponibles: item.CamasDisponibles,
                ocupadas: item.CamasOcupadas,
                reservadas: item.CamasReservadas,
                bloqueadas: item.CamasBloqueadas,
              }
              setTotals(newTotals)
            } catch (e) {
              // Si falla, nos quedamos con los fallbackTotals
            }

            setPagination({
              ...currentPagination,
              totalResults: response.total || 0,
            })
          } else {
            console.warn('Response data is not a valid array:', response.data)
            setTableData([])
            setData([])
            setPagination({
              ...currentPagination,
              totalResults: 0,
            })
          }
        } else {
          console.error('Service error:', response.message)
          setTableData([])
          setData([])
          setPagination({
            ...currentPagination,
            totalResults: 0,
          })
          if (response.message) {
            getSnackBarToast(response.message, 'error')
          }
        }
        setLoading(false)
      } catch (error: any) {
        console.error('Error loading table data:', error)
        setLoading(false)
        setTableData([])
        setData([])
        setPagination({
          ...pagination,
          totalResults: 0,
        })
        getSnackBarToast(
          error?.response?.data?.message || 'Error al cargar los datos de la tabla',
          'error',
        )
      }
    }

    const handleTotalsDoubleClick = (estadoCama?: string) => {
      const nextEstadoCama = estadoCama || ''
      setEstadoCamaFilter(nextEstadoCama)
      clearSelected()

      const filters = nextEstadoCama ? {EstadoCama: nextEstadoCama} : {EstadoCama: ''}
      if (pagination.currentPage === 1) {
        loadTableData(filters)
        return
      }

      const newPagination = {...pagination, currentPage: 1}
      setPagination(newPagination)
      loadTableData(filters, newPagination)
    }

    const getTotalCardProps = (onDoubleClick: () => void, title: string, className = '') => ({
      className: `border rounded p-3 h-100 ${className}`.trim(),
      style: {cursor: 'pointer', transition: 'all 0.2s ease-in-out'},
      onDoubleClick,
      title,
      onMouseEnter: (e: React.MouseEvent<HTMLDivElement>) => {
        e.currentTarget.style.transform = 'translateY(-2px)'
        e.currentTarget.style.boxShadow = '0 0.5rem 1rem rgba(0, 0, 0, 0.15)'
      },
      onMouseLeave: (e: React.MouseEvent<HTMLDivElement>) => {
        e.currentTarget.style.transform = 'translateY(0)'
        e.currentTarget.style.boxShadow = 'none'
      },
    })

    useEffect(() => {
      if (formValue.CampamentoId) {
        if (pagination.currentPage === 1) {
          loadTableData()
        } else {
          setPagination({...pagination, currentPage: 1})
        }
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Campamento requerido',
          text: 'Debe seleccionar un campamento específico para realizar la búsqueda.',
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formValue])

    useEffect(() => {
      if (updateTable) {
        if (pagination.currentPage === 1) {
          loadTableData()
        } else {
          setPagination({...pagination, currentPage: 1, perPage: 10})
        }
        setUpdateTable(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateTable])

    useEffect(() => {
      if (updateTableDetail) {
        if (pagination.currentPage === 1) {
          loadTableData()
        } else {
          setPagination({...pagination, currentPage: 1, perPage: 10})
        }
        setUpdateTableDetail(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateTableDetail])

    useEffect(() => {
      if (clearTable) {
        setEstadoCamaFilter('')
        if (pagination.currentPage === 1) {
          loadTableData({})
        } else {
          const newPagination = {...pagination, currentPage: 1, perPage: 10}
          loadTableData({}, newPagination)
        }
        setClearTable(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearTable])

    useEffect(() => {
      if (clearTableDetail) {
        setEstadoCamaFilter('')
        if (pagination.currentPage === 1) {
          loadTableData({})
        } else {
          const newPagination = {...pagination, currentPage: 1, perPage: 10}
          loadTableData({}, newPagination)
        }
        setClearTableDetail(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearTableDetail])

    const canSelectItem = (item: TableData) => {
      const estado = item.EstadoReservaCamaNombre?.toUpperCase()

      return estado === 'ASIGNADA' || estado === 'GENERADA'
    }

    const canLiberate = useMemo(() => {
      if (selected.length === 0) return false
      const selectedItems = tableData.filter((item) => {
        return selected.includes(item.ReservaCamaId) || selected.includes(item.Id)
      })
      return selectedItems.every((item) => canSelectItem(item))
    }, [selected, tableData])

    // Notificar al contenedor superior el estado de activación de botones
    useEffect(() => {
      onStatusChange?.({
        canLiberate,
        canGenerate: selected.length > 0,
        loading,
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canLiberate, selected.length, loading])

    const handleLiberacion = async () => {
      if (!canLiberate) {
        Swal.fire({
          icon: 'warning',
          title: 'Advertencia',
          text: 'Solo se pueden liberar camas con estado "Asignada" o "Generada". Por favor seleccione elementos válidos.',
        })
        return
      }

      const selectedItems = tableData.filter((item) => {
        const selectionId = item.ReservaCamaId != null ? item.ReservaCamaId : item.Id
        return selected.includes(selectionId)
      })
      const reservaCamaIds = selectedItems
        .map((item) => ({
          Id: item.ReservaCamaId,
          UsuarioId: (item as any).UsuarioId || (item as any).UsuarioIdAnterior || null,
        }))
        .filter((id) => id.Id != null)

      try {
        const result = await Swal.fire({
          title: '¿Está seguro?',
          text: `Se liberarán ${reservaCamaIds.length} cama(s). Esta acción no se puede deshacer.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, liberar',
          cancelButtonText: 'Cancelar',
        })

        if (result.isConfirmed) {
          setLoading(true)
          const response = await deleteReserveBedBatchService(reservaCamaIds)

          if (response.data && !response.data.error) {
            getSnackBarToast('Camas liberadas exitosamente', 'success')
            clearSelected()
            setTableData((prevData) =>
              prevData.map((item) => ({
                ...item,
                HuespedId: null,
                UsuarioId: null,
                HuespedObservacionNombreCompleto: null,
                HuespedBuscadorHabilitado: false,
                HuespedIdAnterior: null,
                UsuarioIdAnterior: null,
                HuespedObservacionNombreCompletoAnterior: null,
                HuespedOcupado: false,
                CamaIdPosicion: null,
              })),
            )
            loadTableData()
          } else {
            getSnackBarToast(response.data?.message || 'Error al liberar las camas', 'error')
          }
          setLoading(false)
        }
      } catch (error: any) {
        setLoading(false)
        getSnackBarToast(error?.response?.data?.message || 'Error al liberar las camas', 'error')
      }
    }

    const handleGeneracion = () => {
      if (selected.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Advertencia',
          text: 'Por favor seleccione al menos un elemento para generar.',
        })
        return
      }

      const selectedItems = tableData.filter((item) => {
        const selectionId = item.ReservaCamaId != null ? item.ReservaCamaId : item.Id
        return selected.includes(selectionId)
      })

      const itemsSinHuesped = selectedItems.filter(
        (item) => !item.HuespedId, // || !(item as any).UsuarioId
      )

      if (itemsSinHuesped.length > 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error de validación',
          text: `Hay ${itemsSinHuesped.length} registro(s) sin huésped seleccionado.`,
        })
        return
      }

      setShowModalGenerarReserva(true)
    }

    const printPdf = (pdfUrl: string) => {
      const printWindow = window.open(pdfUrl, '_blank')
      if (printWindow) {
        printWindow.addEventListener('load', () => {
          printWindow.focus()
          printWindow.print()
        })
      }
    }

    const handleConfirmGenerarReserva = async (modalData: {
      fechaIni: string
      fechaFin: string
      checkin: boolean
      impresion?: boolean
    }) => {
      try {
        setLoading(true)
        const selectedItems = tableData.filter((item) => {
          const estadoCama = item.EstadoCamaNombre?.toUpperCase()
          const esDisponible = estadoCama === 'DISPONIBLE'
          const tieneReservaId = item.ReservaId != null
          const selectionId =
            esDisponible && !tieneReservaId ? item.Id : item.ReservaCamaId || item.Id

          return selected.includes(selectionId)
        })

        console.log({selectedItems})

        const data = selectedItems.map((item) => {
          const itemData: any = {
            camaId: item.CamaId,
            huespedId: item.HuespedId || (item as any).HuespedIdAnterior,
            usuarioId: (item as any).UsuarioId || (item as any).UsuarioIdAnterior || null,
            camaCalienteId: item.CamaCalienteId || null,
          }

          // Solo agregar campos de checkout si hay ReservaCamaId y NO es disponible sin ReservaId
          const estadoCama = item.EstadoCamaNombre?.toUpperCase()
          const esDisponible = estadoCama === 'DISPONIBLE'
          const tieneReservaId = item.ReservaId != null

          if (item.ReservaCamaId && !(esDisponible && !tieneReservaId)) {
            itemData.checkout = 'true'
            itemData.checkout_reservacamaId = item.ReservaCamaId
            itemData.checkout_estadocama = item.EstadoCamaNombre || 'RESERVADA'
          }

          return itemData
        })

        const requestBody = {
          fechaIni: modalData.fechaIni,
          fechaFin: modalData.fechaFin,
          campamentoId: formValue.CampamentoId,
          data: data,
        }

        const response = await createReserveCheckInBatchService(requestBody)

        if (response.data && !response.data.error) {
          getSnackBarToast('Reservas generadas exitosamente', 'success')

          // Impresión de comprobantes (misma lógica que en FormBookingftf)
          try {
            if (modalData.impresion) {
              const respData = response.data?.data
              let reservaIds: any[] = []
              if (Array.isArray(respData)) {
                reservaIds = respData
                  .map((x) => x?.reservaCamaId || x?.ReservacamaId || x?.ReservaCamaId)
                  .filter(Boolean)
              } else {
                const one =
                  respData?.reservaCamaId || respData?.ReservacamaId || respData?.reservacamaid
                if (one) reservaIds = [one]
              }

              // Si es un solo registro, mostrar modal con botón de imprimir ticket
              if (reservaIds.length === 1) {
                const id = reservaIds[0]
                const pdfDto = {
                  reservaCamaId: id,
                  tipo: 'IN',
                  MotivoReimpresionId: '',
                  Otros: '',
                }
                const pdfResponse = await downloadPDFCheckInOutService(pdfDto)
                const blob = new Blob([pdfResponse.data], {type: 'application/pdf'})
                const url = window.URL.createObjectURL(blob)
                setTimeout(() => {
                  printPdf(url)
                }, 1000)
                Swal.fire({
                  title: 'Se ha realizado el check-in',
                  html: `<div id="print_pdf">
                      <button
                        id='printButton'
                        class='sdx_btn m-auto'
                        type='button'
                      >Imprimir Ticket Checkin</button>
                    </div>`,
                  icon: 'success',
                  showLoaderOnConfirm: true,
                  allowOutsideClick: () => !Swal.isLoading(),
                  didOpen: () => {
                    const printButton = document.getElementById('printButton') as HTMLElement
                    printButton?.addEventListener('click', () => printPdf(url))
                  },
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    Swal.close()
                  }
                })
              } else {
                // Más de un registro: mantener descarga directa actual
                for (const id of reservaIds) {
                  const pdfDto = {
                    reservaCamaId: id,
                    tipo: 'IN',
                    MotivoReimpresionId: '',
                    Otros: '',
                  }
                  const pdfResponse = await downloadPDFCheckInOutService(pdfDto)
                  const blob = new Blob([pdfResponse.data], {type: 'application/pdf'})
                  const url = window.URL.createObjectURL(blob)
                  const link = document.createElement('a')
                  link.href = url
                  link.download = `CheckIn-${id}.pdf`
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                }
              }
            }
          } catch (pdfError) {
            console.error('Error descargando PDF:', pdfError)
          }

          clearSelected()
          // Limpiar todos los datos de huésped
          setTableData((prevData) =>
            prevData.map((item) => ({
              ...item,
              HuespedId: null,
              UsuarioId: null,
              HuespedObservacionNombreCompleto: null,
              HuespedBuscadorHabilitado: false,
              HuespedIdAnterior: null,
              UsuarioIdAnterior: null,
              HuespedObservacionNombreCompletoAnterior: null,
              HuespedOcupado: false,
              CamaIdPosicion: null,
            })),
          )
          loadTableData()
        } else {
          getSnackBarToast(response.data?.message || 'Error al generar las reservas', 'error')
        }
        setLoading(false)
      } catch (error: any) {
        setLoading(false)
        getSnackBarToast(error?.response?.data?.message || 'Error al generar las reservas', 'error')
      }
    }

    useEffect(() => {
      if (!loading && tableData.length > 0 && pagination.totalResults > 0) {
        loadTableData()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination.currentPage])

    const loadOptionsGuest = useCallback(
      async (inputValue: string, rowId?: string | number, rowIndex?: number) => {
        try {
          if (inputValue.length < 3 || !formValue.CampamentoId) {
            return []
          }

          const isValidDni = /^\d{8}$/.test(inputValue)

          const request = {
            campamentoId: formValue.CampamentoId,
            nroDoc: inputValue,
          }
          const response = await getListComboHuespedService(request)
          const data = response.data.data || []

          // Si no hay resultados y es un DNI válido, mostrar modal para crear huésped
          if (data.length === 0 && isValidDni) {
            // Si hay rowIndex, usar el índice del array; de lo contrario usar rowId
            if (rowIndex !== undefined && rowIndex !== null) {
              setPendingRowId(rowIndex)
            } else if (rowId) {
              setPendingRowId(rowId)
            }
            showModalPopup(inputValue)
            return []
          }

          const mappedGuest = data?.map((item: any) => ({
            value: item.Id,
            label: `${item.Nombres || ''} ${item.ApellidoPaterno || ''} ${
              item.ApellidoMaterno || ''
            } (${item.NumeroDocumento || ''})`,
            ...item,
          }))
          return mappedGuest || []
        } catch (error) {
          console.error('Error fetching guest options:', error)
          return []
        }
      },
      [formValue.CampamentoId],
    )

    const showModalPopup = (inputValue: string) => {
      Swal.fire({
        title: 'Crear Huésped',
        text: 'Este numero de documento no está registrado. ¿Desea crear un nuevo huésped?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, crear',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const tipoDoc = '01' // Por defecto DNI
          setPendingDocumento({numero: inputValue, tipo: tipoDoc})
          setShowModalCreateGuest(true)
          Swal.close()
        }
      })
    }

    const handleGuestCreated = async (guest: GuestModel) => {
      // Guardar HuespedId y UsuarioId en la fila correspondiente
      if (pendingRowId !== null && pendingRowId !== undefined) {
        const guestData = guest as any
        const nombreCompleto = `${guest.Nombres || ''} ${guest.ApellidoPaterno || ''} ${
          guest.ApellidoMaterno || ''
        }`.trim()
        const sexo = guestData?.Sexo || guest?.Sexo_descripcion || null
        const cargoId = guest?.CargoId ? String(guest.CargoId) : ''
        const cargo = guestData?.Cargo_descripcion || (cargoId ? cargoById[cargoId] || null : null)
        setTableData((prevData) =>
          prevData.map((item, index) => {
            // Verificar si el estado de la cama es "disponible" para guardar el CamaId
            const estadoCama = item.EstadoCamaNombre?.toUpperCase()
            const esDisponible = estadoCama === 'DISPONIBLE'
            const tieneReservaId = item.ReservaId != null

            // Si es disponible sin ReservaId, usar el índice del array para identificar el registro
            // De lo contrario, usar ReservaCamaId o Id
            const isMatch =
              esDisponible && !tieneReservaId
                ? index === pendingRowId
                : item.ReservaCamaId === pendingRowId || item.Id === pendingRowId

            if (isMatch) {
              return {
                ...item,
                HuespedId: String(guest.Id),
                UsuarioId: guest.UsuarioId ? String(guest.UsuarioId) : null,
                HuespedObservacionNombreCompleto: nombreCompleto,
                NroDoc: guest.NumeroDocumento || item.NroDoc,
                Sexo: sexo,
                Cargo: cargo,
                // Si el estado es disponible, guardar el CamaId como id de posición
                CamaIdPosicion: esDisponible ? item.CamaId || null : null,
              }
            }
            return item
          }),
        )
        setPendingRowId(null)
      }
      setShowModalCreateGuest(false)
      setPendingDocumento(null)
    }

    // Efecto para manejar la habilitación del buscador cuando se selecciona/deselecciona una fila
    useEffect(() => {
      setTableData((prevData) =>
        prevData.map((item) => {
          // Calcular el selectionId igual que en la celda de selección
          const selectionId = item.ReservaCamaId != null ? item.ReservaCamaId : item.Id
          const estaSeleccionado = selected.includes(selectionId)
          const estabaSeleccionado = (item as any).HuespedBuscadorHabilitado || false

          // Si se selecciona y antes no estaba seleccionado
          if (estaSeleccionado && !estabaSeleccionado) {
            return {
              ...item,
              HuespedBuscadorHabilitado: true,
            }
          }

          // Si se deselecciona y antes estaba seleccionado
          if (!estaSeleccionado && estabaSeleccionado) {
            const tieneValoresAnteriores =
              (item as any).HuespedIdAnterior || (item as any).UsuarioIdAnterior
            return {
              ...item,
              HuespedBuscadorHabilitado: false,
              // Volver al valor inicial del servicio; si no había, dejar en blanco
              HuespedId: tieneValoresAnteriores ? (item as any).HuespedIdAnterior : undefined,
              UsuarioId: tieneValoresAnteriores ? (item as any).UsuarioIdAnterior : null,
              HuespedObservacionNombreCompleto: tieneValoresAnteriores
                ? (item as any).HuespedObservacionNombreCompletoAnterior
                : null,
              NroDoc: tieneValoresAnteriores ? (item as any).NroDocAnterior : null,
            }
          }

          // Si está seleccionado pero el flag no está actualizado, actualizarlo
          if (estaSeleccionado && !estabaSeleccionado) {
            return {
              ...item,
              HuespedBuscadorHabilitado: true,
            }
          }

          // Si está seleccionado, mantener el flag en true
          if (estaSeleccionado) {
            return {
              ...item,
              HuespedBuscadorHabilitado: true,
            }
          }

          return item
        }),
      )
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected])

    const handleChangeGuestObservacion = async (
      selectedGuest: any,
      row: TableData,
      rowIndex?: number,
    ) => {
      if (selectedGuest) {
        const nombreCompleto = `${selectedGuest.Nombres || ''} ${
          selectedGuest.ApellidoPaterno || ''
        } ${selectedGuest.ApellidoMaterno || ''}`.trim()

        const estadoCama = row.EstadoCamaNombre?.toUpperCase()
        const esDisponible = estadoCama === 'DISPONIBLE'
        const tieneReservaId = row.ReservaId != null

        let huespedOcupado = false
        let puedeGuardar = true

        try {
          const request = {
            huespedId: selectedGuest.value,
            fechaini: formValue.Fecha,
            fechafin: formValue.Fecha,
          }
          const response = await getHuespedEsRelevoService(request)

          if (response.data.error) {
            puedeGuardar = false
            Swal.fire({
              icon: 'warning',
              title: 'Huésped ocupado',
              text: response.data.message || 'Este huésped ya tiene una cama asignada.',
            })
          } else {
            const relevoDataResponse: any = response.data.data
            const relevoIdValue = relevoDataResponse.relevoId || relevoDataResponse.RelevoId
            huespedOcupado = !!relevoIdValue
          }
        } catch (error) {
          console.error('Error validando huésped:', error)
          puedeGuardar = false
        }

        if (!puedeGuardar) {
          return
        }

        setTableData((prevData) =>
          prevData.map((item, index) => {
            const isMatch =
              esDisponible && !tieneReservaId
                ? index === rowIndex
                : item.ReservaCamaId === row.ReservaCamaId || item.Id === row.Id

            if (isMatch) {
              return {
                ...item,
                HuespedId: String(selectedGuest.value),
                UsuarioId: selectedGuest.UsuarioId ? String(selectedGuest.UsuarioId) : null,
                HuespedObservacionNombreCompleto: nombreCompleto,
                NroDoc: selectedGuest.NumeroDocumento || item.NroDoc,
                CamaIdPosicion: esDisponible ? row.CamaId || null : null,
                HuespedOcupado: huespedOcupado,
              }
            }
            return item
          }),
        )
      } else {
        setTableData((prevData) =>
          prevData.map((item, index) => {
            const estadoCama = row.EstadoCamaNombre?.toUpperCase()
            const esDisponible = estadoCama === 'DISPONIBLE'
            const tieneReservaId = row.ReservaId != null
            const isMatch =
              esDisponible && !tieneReservaId
                ? index === rowIndex
                : item.ReservaCamaId === row.ReservaCamaId || item.Id === row.Id

            if (isMatch) {
              const tieneValoresAnteriores =
                (item as any).HuespedIdAnterior || (item as any).UsuarioIdAnterior
              const selectionId = item.ReservaCamaId != null ? item.ReservaCamaId : item.Id
              const estaSeleccionado = selected.includes(selectionId)

              return {
                ...item,
                // Si había huésped previo, restaurarlo; si no, limpiar valores
                HuespedId: tieneValoresAnteriores ? (item as any).HuespedIdAnterior : undefined,
                UsuarioId: tieneValoresAnteriores ? (item as any).UsuarioIdAnterior : null,
                HuespedObservacionNombreCompleto: tieneValoresAnteriores
                  ? (item as any).HuespedObservacionNombreCompletoAnterior
                  : null,
                NroDoc: tieneValoresAnteriores ? (item as any).NroDocAnterior : null,
                CamaIdPosicion: tieneValoresAnteriores ? item.CamaIdPosicion : null,
                HuespedOcupado: null,
                // Mantener habilitado el buscador si la fila sigue seleccionada
                HuespedBuscadorHabilitado: estaSeleccionado,
                HuespedIdAnterior: tieneValoresAnteriores ? (item as any).HuespedIdAnterior : null,
                UsuarioIdAnterior: tieneValoresAnteriores ? (item as any).UsuarioIdAnterior : null,
                HuespedObservacionNombreCompletoAnterior: tieneValoresAnteriores
                  ? (item as any).HuespedObservacionNombreCompletoAnterior
                  : null,
              }
            }
            return item
          }),
        )
      }
    }

    const handleExportExcel = async () => {
      try {
        const obj = {...formValue}
        for (const clave in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, clave) && obj[clave] === '') {
            obj[clave] = null
          }
        }

        const formValues = {
          pageNumber: pagination.currentPage,
          size: pagination.perPage,
          ...obj,
          ...searchValues,
          ...(searchValues.CamaCaliente === 'SI'
            ? {CamaCaliente: true}
            : searchValues.CamaCaliente === 'NO'
            ? {CamaCaliente: false}
            : {CamaCaliente: null}),
        }

        // Incluir EstadoCama si hay filtro activo (igual que en loadTableData)
        if (estadoCamaFilter) {
          ;(formValues as any).EstadoCama = estadoCamaFilter
        } else {
          if (Object.prototype.hasOwnProperty.call(formValues as any, 'EstadoCama')) {
            delete (formValues as any).EstadoCama
          }
        }

        const response = await getRatioRoomingListResumidoExcelService(formValues)
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `Ratios Rooming Resumido-${moment().format('DD-MM-YY HH-mm')}.xlsx`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        getSnackBarToast('Se descargó el documento con éxito', 'success')
      } catch (error) {
        getSnackBarToast('Hubo un error al descargar', 'error')
        throw error
      }
    }

    useImperativeHandle(ref, () => ({
      handleSearch: () => {
        setUpdateTable(true)
      },
      handleLiberacion: () => {
        handleLiberacion()
      },
      handleGeneracion: () => {
        handleGeneracion()
      },
      handleExportExcel: async () => {
        await handleExportExcel()
      },
    }))

    const columns: Column<TableData>[] = useMemo(
      () => [
        {
          Header: (props) => <KTableHeader tableProps={props} showSelect={true} />,
          id: 'selection',
          width: 36,
          minWidth: 28,
          maxWidth: 44,
          Cell: ({...props}) => {
            const item = props.data[props.row.index]
            const selectionId = item.ReservaCamaId != null ? item.ReservaCamaId : item.Id
            return <KTableSelectionCell id={selectionId} />
          },
        },
        {
          Header: (props) => (
            <KTableHeader
              tableProps={props}
              title='ESTADO RESERVA CAMA'
              name='EstadoReservaCamaId'
              size='155px'
              selecteable
              data={statusType}
              wrapTitle
            />
          ),
          accessor: 'EstadoReservaCamaNombre',
          minWidth: 100,
          width: 120,
        },
        {
          Header: (props) => (
            <KTableHeader
              tableProps={props}
              title='MOD'
              name='CodigoModulo'
              searcheable
              wrapTitle
            />
          ),
          accessor: 'ModuloCodigo',
          width: 80,
          minWidth: 72,
          maxWidth: 100,
        },
        {
          Header: (props) => (
            <KTableHeader
              tableProps={props}
              title='HAB'
              name='CodigoHabitacion'
              searcheable
              wrapTitle
            />
          ),
          accessor: 'HabitacionCodigo',
          width: 80,
          minWidth: 80,
          maxWidth: 100,
        },
        {
          Header: (props) => (
            <KTableHeader tableProps={props} title='CAM' name='CodigoCama' searcheable wrapTitle />
          ),
          accessor: 'CamaCodigo',
          width: 80,
          minWidth: 80,
          maxWidth: 110,
        },
        {
          Header: (props) => (
            <KTableHeader
              tableProps={props}
              title='CAMA CALIENTE'
              name='CamaCaliente'
              selecteable
              data={camaCaliente || []}
              wrapTitle
            />
          ),
          accessor: 'CamaCaliente',
          width: 130,
          minWidth: 80,
          maxWidth: 130,
          Cell: (props) => <>{props.row.original.CamaCalienteId ? 'SI' : 'NO'}</>,
        },
        {
          Header: (props) => (
            <KTableHeader
              tableProps={props}
              title='NRO DOCUMENTO'
              name='NroDoc'
              searcheable
              wrapTitle
            />
          ),
          accessor: 'NroDoc',
          width: 120,
          minWidth: 120,
          maxWidth: 180,
        },
        {
          Header: (props) => (
            <KTableHeader
              tableProps={props}
              title='HUÉSPED'
              name='HuespedNombres'
              searcheable
              wrapTitle
            />
          ),
          accessor: 'HuespedNombre',
          width: 240,
          minWidth: 320,
          Cell: ({...props}) => {
            const row = props.data[props.row.index]
            const huespedId = row.HuespedId
            const huespedObservacionNombreCompleto = (row as any).HuespedObservacionNombreCompleto
            const style = {
              container: (base: any) => ({
                ...base,
                width: '100%',
                minWidth: 0,
              }),
              control: (base: any) => ({
                ...base,
                minHeight: '32px',
                fontSize: '14px',
                width: '100%',
                minWidth: 0,
              }),
              menu: (base: any) => ({
                ...base,
                zIndex: 9999,
                width: 'auto',
                minWidth: '100%',
              }),
              menuPortal: (base: any) => ({...base, zIndex: 9999}),
              valueContainer: (base: any) => ({
                ...base,
                overflow: 'hidden',
              }),
            }

            const estadoCama = row.EstadoCamaNombre?.toUpperCase()
            const esDisponible = estadoCama === 'DISPONIBLE'
            const tieneReservaId = row.ReservaId != null
            const rowIdForSelection = esDisponible && !tieneReservaId ? row.Id : row.ReservaCamaId

            const loadOptionsWithRowId = async (inputValue: string) => {
              return loadOptionsGuest(
                inputValue,
                rowIdForSelection,
                esDisponible && !tieneReservaId ? props.row.index : undefined,
              )
            }

            const selectionId = row.ReservaCamaId != null ? row.ReservaCamaId : row.Id
            const estaSeleccionado = selected.includes(selectionId)
            const buscadorHabilitado = estaSeleccionado

            return (
              <div style={{width: '100%', minWidth: 0}}>
                <AsyncSelect
                  key={`guest-select-${rowIdForSelection}`}
                  cacheOptions
                  defaultOptions={false}
                  loadOptions={loadOptionsWithRowId as any}
                  menuPortalTarget={document.body}
                  styles={style}
                  noOptionsMessage={() => 'No hay resultados'}
                  isDisabled={!buscadorHabilitado}
                  value={
                    huespedId
                      ? {
                          value: huespedId,
                          label:
                            huespedObservacionNombreCompleto ||
                            row.HuespedNombre ||
                            `ID: ${huespedId}`,
                        }
                      : null
                  }
                  onChange={(event: any) =>
                    handleChangeGuestObservacion(event, row, props.row.index)
                  }
                  placeholder='Busca un huésped...'
                />
              </div>
            )
          },
        },
        {
          Header: (props) => (
            <KTableHeader tableProps={props} title='GÉNERO' searcheable name='Genero' wrapTitle />
          ),
          accessor: 'Sexo',
          width: 100,
          minWidth: 90,
          maxWidth: 120,
          Cell: ({value}) => <>{value || '-'}</>,
        },
        {
          Header: (props) => (
            <KTableHeader tableProps={props} title='CARGO' searcheable name='Cargo' wrapTitle />
          ),
          accessor: 'Cargo',
          width: 160,
          minWidth: 140,
          Cell: ({value}) => <>{value || '-'}</>,
        },
        {
          Header: (props) => (
            <KTableHeader
              tableProps={props}
              title='EMPRESA SUBCONTRATISTA'
              name='EmpresaId'
              searcheable
              wrapTitle
            />
          ),
          accessor: 'HuespedEmpresaNombre',
          minWidth: 240,
        },
        {
          Header: (props) => (
            <KTableHeader
              tableProps={props}
              title='FECHA CHECKIN'
              name='FechaCheckIn'
              dateable
              wrapTitle
            />
          ),
          accessor: 'FechaCheckIn',
          minWidth: 130,
          width: 130,
          Cell: ({value}) => <>{value ? moment(value).format('DD/MM/YYYY') : '-'}</>,
        },
        {
          Header: (props) => (
            <KTableHeader
              tableProps={props}
              title='FECHA PROGRAMADA DE CHECKOUT'
              name='FechaCheckOut'
              dateable
              wrapTitle
            />
          ),
          accessor: 'FechaCheckOut',
          minWidth: 160,
          width: 160,
          Cell: ({value}) => <>{value ? moment(value).format('DD/MM/YYYY') : '-'}</>,
        },
      ],
      [enterprises, statusType, bedTypes, statusBed, selected],
    )

    // stats ahora provienen del servicio; si falla, quedan los fallbackTotals ya seteados

    return (
      <>
        <div className='m-3 bg-white rounded'>
          {loading && <KTableLoading />}
          {!loading && (
            <>
              <div className='p-4 border-bottom'>
                <div className='row g-3'>
                  <div className='col-12 col-md-6 col-lg'>
                    <div
                      {...getTotalCardProps(
                        () => handleTotalsDoubleClick(''),
                        'Doble click para ver todas las camas',
                        '',
                      )}
                    >
                      <div className='fs-8' style={{color: '#0d6efd'}}>
                        CAMAS TOTALES
                      </div>
                      <div className='fw-bold fs-2' style={{color: '#0d6efd'}}>
                        {totals.total}
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-md-6 col-lg'>
                    <div
                      {...getTotalCardProps(
                        () => handleTotalsDoubleClick('DISPONIBLE'),
                        'Doble click para filtrar por camas disponibles',
                      )}
                    >
                      <div className='text-success fs-8'>DISPONIBLES</div>
                      <div className='fw-bold fs-2 text-success'>{totals.disponibles}</div>
                    </div>
                  </div>
                  <div className='col-12 col-md-6 col-lg'>
                    <div
                      {...getTotalCardProps(
                        () => handleTotalsDoubleClick('OCUPADA'),
                        'Doble click para filtrar por camas ocupadas',
                      )}
                    >
                      <div className='text-danger fs-8'>OCUPADAS</div>
                      <div className='fw-bold fs-2 text-danger'>{totals.ocupadas}</div>
                    </div>
                  </div>
                  <div className='col-12 col-md-6 col-lg'>
                    <div
                      {...getTotalCardProps(
                        () => handleTotalsDoubleClick('RESERVADA'),
                        'Doble click para filtrar por camas reservadas',
                      )}
                    >
                      <div className='text-warning fs-8'>RESERVADAS</div>
                      <div className='fw-bold fs-2 text-warning'>{totals.reservadas}</div>
                    </div>
                  </div>
                  <div className='col-12 col-md-6 col-lg'>
                    <div
                      {...getTotalCardProps(
                        () => handleTotalsDoubleClick('BLOQUEADA'),
                        'Doble click para filtrar por camas bloqueadas',
                      )}
                    >
                      <div className='text-secondary fs-8'>BLOQUEADAS</div>
                      <div className='fw-bold fs-2 text-secondary'>{totals.bloqueadas}</div>
                    </div>
                  </div>
                </div>
              </div>
              <KTable
                data={tableData}
                columns={columns as any}
                paddingTable={false}
                size='small'
                showPageSizeSelector
                paginationArrowsNextToPageSize
                paginationLeftActions={paginationLeftActions}
                classNameProps='k-liberacion-table'
                enableFixedLayout
              />
            </>
          )}
        </div>
        {showModalCreateGuest && (
          <ModalCreateGuest
            key={pendingDocumento?.numero || 'modal-guest'}
            show={showModalCreateGuest}
            setShow={setShowModalCreateGuest}
            campamentoId={formValue.CampamentoId || ''}
            onGuestCreated={handleGuestCreated}
            numeroDocumento={pendingDocumento?.numero || ''}
            tipoDocumentoId={pendingDocumento?.tipo || '01'}
            showCargoField
          />
        )}

        <ModalGenerarReserva
          show={showModalGenerarReserva}
          setShow={setShowModalGenerarReserva}
          onConfirm={handleConfirmGenerarReserva}
        />
      </>
    )
  },
)

const TableReportLiberacionGeneracionWrapper = forwardRef<TableLiberacionGeneracionRef, Props>(
  ({formValue, onStatusChange, paginationLeftActions}, ref) => {
    return (
      <KTableProvider>
        <TableReportLiberacionGeneracion
          ref={ref}
          formValue={formValue}
          onStatusChange={onStatusChange}
          paginationLeftActions={paginationLeftActions}
        />
        <SnackbarProvider />
      </KTableProvider>
    )
  },
)

export {TableReportLiberacionGeneracionWrapper}
